import { Skeleton } from '@fp/ui-kit'

interface FilterSkeletonsProps {
  count: number
}

export const FilterSkeletons = ({ count }: FilterSkeletonsProps) => (
  <>
    {Array.from({ length: count }, (_, idx) => (
      <div key={idx} className='flex flex-col gap-2 animate-fade-in'>
        <Skeleton className='h-3 max-w-20' />
        <Skeleton className='h-10 max-w-full' />
      </div>
    ))}
  </>
)
